export function checkStorageValue (value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


//////////////////
// WEBPACK FOOTER
// ../work/src/~/tiny-slider/src/helpers/checkStorageValue.js
// module id = 31
// module chunks = 0